import AuthApiService from "@/core/services/authapi.service";
import JwtService from "@/core/services/jwt.service";
import Vue from "vue";
import Router from "../../../router";
import store from "./index";
import { SELECT_PHARMACY } from "./pharmacy.module";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";
export const SET_USER_ROLES = "setUserRoles";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_ERROR = "setError";
export const UPDATE_USER_ROLES = "updateUserRoles";

const state = {
  errors: [],
  user: {},
  isAuthenticated: !!JwtService.getToken(),
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  hasRoles(roles) {
    for (let i = 0; i < roles.length; i++) {
      const role1 = roles[i];
      if (state.user.roles) {
        for (let j = 0; j < state.user.roles.length; j++) {
          const role2 = state.user.roles[j];
          if (role1 == role2) return true;
        }
      }
    }
    return false;
  },
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise((resolve, reject) => {
      AuthApiService.post("signin/admin", credentials)
        .then(({ data }) => {
          if (data.state == 1) {
            context.commit(SET_AUTH, data);
          }

          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  [REGISTER](context, credentials) {
    return new Promise((resolve, reject) => {
      AuthApiService.post("users", { user: credentials })
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          //context.commit(SET_ERROR, response.data.errors);
          reject(response);
        });
    });
  },
  [VERIFY_AUTH](context) {
    if (JwtService.getToken()) {
      // ApiService.setHeader();
      // ApiService.get("verify")
      //   .then(({ data }) => {
      //     context.commit(SET_AUTH, data);
      //   })
      //   .catch(({ response }) => {
      //     context.commit(SET_ERROR, response.data.errors);
      //   });
    } else {
      context.commit(PURGE_AUTH);
    }
  },
  [UPDATE_USER](context, payload) {
    const { email, username, password, image, bio } = payload;
    const user = { email, username, bio, image };
    if (password) {
      user.password = password;
    }

    return AuthApiService.put("user", user).then(({ data }) => {
      context.commit(SET_AUTH, data);
      return data;
    });
  },
  [SET_USER_ROLES](context, roles) {
    context.commit(UPDATE_USER_ROLES, roles);
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, data) {
    state.isAuthenticated = true;
    state.user = { userName: data.token.userName, email: data.token.email, roles : [] };
    state.errors = {};
    JwtService.saveToken(data.token.token);
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};

    store.dispatch(SELECT_PHARMACY, {});
    JwtService.destroyToken();
    Vue.prototype.stopSignalR();
    Router.push({ name: "login" });
  },
  [UPDATE_USER_ROLES](state, roles) {
    state.user.roles = roles;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
